var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0925751 6.79055L7.14549 0.086732C7.26716 -0.0289107 7.46457 -0.0289107 7.58624 0.086732L8.90867 1.34369C9.03044 1.45943 9.03044 1.64697 8.90867 1.76271L3.39856 7.00001L8.90867 12.2373C9.03044 12.353 9.03044 12.5406 8.90867 12.6563L7.58624 13.9132C7.46457 14.0289 7.26716 14.0289 7.14549 13.9132L0.0925751 7.20947C-0.030858 7.09215 -0.030858 6.90787 0.0925751 6.79055Z",
    fill: "#106C3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.d3772eaea6e1f61a6d2dfaae01962c40.svg";
export { ForwardRef as ReactComponent };